import i18next from 'i18next';

export const IIRSA_ITEMS = [
  {
    name: i18next.t('navbar:home'),
    pathname: '/home',
    hash: '',
    iconName: 'home'
  },
  {
    name: i18next.t('navbar:projects'),
    pathname: '/actions',
    hash: '',
    iconName: 'projects'
  },
  {
    name: i18next.t('navbar:territories'),
    pathname: '/territories',
    hash: '',
    iconName: 'road'
  },
  {
    name: i18next.t('navbar:maps'),
    pathname: '/territories/map',
    hash: '',
    iconName: 'map'
  },
  {
    name: i18next.t('navbar:charts'),
    pathname: '/territories/charts',
    hash: '',
    iconName: 'charts'
  },
];
